// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YD9Xs","question":"styles_question__2juFX","inputVisibleButton":"styles_inputVisibleButton__2eYOA","note":"styles_note__AzP-t"};